module.exports = "<div *ngIf='!project'>Please, wait &hellip;</div>\n<div *ngIf='project'>\n  <a routerLink=\"/project/{{project.id}}\"\n    routerLinkActive=\"current\">Summary</a>\n</div>\n<div *ngIf='topic'>\n  <h1>Topic: {{topic.title}}</h1>\n  <app-search-term-box *ngFor='let st of topic.searchTermList'\n    [searchTerm]='st'>\n  </app-search-term-box>\n  <app-db-record-topic-box *ngFor='let dbr of topicDbRecords'\n    [project]='project'\n    [topic]='topic'\n    [dbRecord]='dbr'>\n  </app-db-record-topic-box>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/topic-summary/topic-summary.component.html
// module id = 449
// module chunks = 0